import { gql } from '@apollo/client'

export const pyramidForecastFragment = gql`
  fragment PyramidForecastFragment on PyramidForecastDTO {
    id
    forecastId
    employeeId
    employeeFullName
    newHiringFullName
    businessUnitId
    salary
    bonus
    age
    currentEmployeeLevel
    levelChange
    dateOfLevelChange
    forecastDate
    forecastEndDate
    startDate
    endDate
    tags
    businessUnitName
    currencyForPayments
    careerPath {
      salaryEvaluation
      bonusEvaluation
      summary
      salary
      targetBonus
    }
    employeeTimezone
  }
`
